import { Box, Group, Text, Title } from "@mantine/core";
import React from "react";

interface CPTSectionHeaderProps {
  number?: number;
  title: string;
}

const CPTSectionHeader: React.FC<CPTSectionHeaderProps> = ({ number, title }) => (
  <Group gap="sm" align="baseline" wrap="nowrap" className="cpt-section-header">
    {number !== undefined ? (
      <Text component="span" className="cpt-section-number">
        {number}
      </Text>
    ) : null}
    <Title order={4} fw={800} className="cpt-section-title">
      {title}
    </Title>
    <Box className="cpt-section-rule" />
  </Group>
);

export default CPTSectionHeader;
